import Vue from 'vue'
import Router from 'vue-router'
import AnalysisCluster from '@/components/Analysis/cluster'
import BasebandPipeline from '@/components/Analysis/baseband_pipeline'
import analysisCandidates from '@/components/Analysis/analysis_candidates'
import pipelineExperts from '@/components/Analysis/pipeline_experts'
import analysisVerification from '@/components/Analysis/analysis_verification'
import ScienceSummary from '@/components/science_summary'
import ScienceCandidates from '@/components/Science/science_candidates'
import EventSummary from '@/components/Science/event_summary'
import PipelineSummary from '@/components/Science/pipeline_summary'
import ScienceCatalog from '@/components/Science/science_catalog'
import NotWiki from '@/components/Science/NotWiki'
import Home from '@/components/Home'
import Admin from '@/components/Admin/Admin'
import Analysis from '@/components/Analysis/Analysis'
import ManageTeams from '@/components/Admin/manage_teams'
import Schedule from '@/components/Outriggers/vlbi_schedule'
import OutriggerEvents from '@/components/Outriggers/outrigger_events'
import BasebandEvents from '@/components/Outriggers/baseband_events'
import OutriggersHome from '@/components/Outriggers/outriggers_home'
import DatatrailHome from '@/components/Datatrail/datatrail_home'
import EventDataAcquisition from '@/components/Outriggers/event_data_acq'
import Login from '@/components/Login'
import Logout from '@/components/Logout'

Vue.use(Router)

export default new Router({
  mode: 'history',
  hash: false,
  routes: [
    {
      path: '/frb-web/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/frb-web/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/frb-web',
      name: 'Home',
      component: Home
    },
    {
      path: '/frb-web/notwiki',
      name: 'NotWiki',
      component: NotWiki
    },
    {
      path: '/frb-web/admin',
      name: 'Admin',
      component: Admin
    },
    {
      path: '/frb-web/analysis',
      name: 'Analysis',
      component: Analysis
    },
    {
      path: '/frb-web/baseband-pipeline',
      name: 'BasebandPipeline',
      component: BasebandPipeline
    },
    {
      path: '/frb-web/teams',
      name: 'ManageTeams',
      component: ManageTeams
    },
    {
      path: '/frb-web/calibrator-schedule',
      name: 'Schedule',
      component: Schedule
    },
    {
      path: '/frb-web/vlbi-events',
      name: 'OutriggerEvents',
      component: OutriggerEvents
    },
    {
      path: '/frb-web/event-acq',
      name: 'EventDataAcquisition',
      component: EventDataAcquisition
    },
    {
      path: '/frb-web/outrigger-home',
      name: 'OutriggersHome',
      component: OutriggersHome
    },
    {
      path: '/frb-web/datatrail',
      name: 'DatatrailHome',
      component: DatatrailHome
    },
    {
      path: '/frb-web/baseband-events',
      name: 'BasebandEvents',
      component: BasebandEvents
    },
    {
      path: '/frb-web/science-candidates',
      name: 'ScienceCandidates',
      component: ScienceCandidates
    },
    {
      path: '/frb-web/analysis-candidates',
      name: 'analysisCandidates',
      component: analysisCandidates
    },
    {
      path: '/frb-web/pipeline-experts',
      name: 'pipelineExperts',
      component: pipelineExperts
    },
    {
      path: '/frb-web/cluster',
      name: 'AnalysisCluster',
      component: AnalysisCluster
    },
    {
      path: '/frb-web/analysis-verification',
      name: 'analysisVerification',
      component: analysisVerification
    },
    {
      path: '/frb-web/science_summary',
      name: 'ScienceSummary',
      component: ScienceSummary
    },
    {
      path: '/frb-web/event_summary',
      name: 'EventSummary',
      component: EventSummary
    },
    {
      path: '/frb-web/pipeline_summary',
      name: 'PipelineSummary',
      component: PipelineSummary
    },
    {
      path: '/frb-web/catalog',
      name: 'ScienceCatalog',
      component: ScienceCatalog
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js